// Auth endpoints — thin wrappers over ApiClient. The token lifecycle
// (where it's stored, when to refresh, what happens on 401) lives in the
// app's auth layer (packages/auth later); this module just types the
// four /v1/api/auth/* calls.

import type { ApiClient } from "./client.js";
import type { LoginRequest, LoginResponse, MeResponse, RefreshResponse } from "./types.js";

export function makeAuthApi(client: ApiClient) {
  return {
    /** POST /v1/api/auth/login — username+password → token + user. */
    login(body: LoginRequest): Promise<LoginResponse> {
      return client.post<LoginResponse>("/v1/api/auth/login", body);
    },
    /** GET /v1/api/auth/me — current user from the bearer token. 401 if not logged in. */
    me(): Promise<MeResponse> {
      return client.get<MeResponse>("/v1/api/auth/me");
    },
    /** POST /v1/api/auth/refresh — extend a still-valid token. */
    refresh(): Promise<RefreshResponse> {
      return client.post<RefreshResponse>("/v1/api/auth/refresh");
    },
    /** POST /v1/api/auth/logout — clears the server cookie (bearer stays valid until expiry; the app drops it client-side). */
    logout(): Promise<{ ok: boolean; note?: string }> {
      return client.post<{ ok: boolean; note?: string }>("/v1/api/auth/logout");
    },
  };
}

export type AuthApi = ReturnType<typeof makeAuthApi>;
